import * as API from "./crud";
import {toast} from "react-toastify";
import {AEToaster} from "../../_emywork/components/toastify/AEAlert";
import React from "react";

export const reportAction = data => {
  return API
    .report(data)
    .then(response=>{
      toast(<AEToaster message={{id:"SENT"}}/>)
    })
    .catch(response=>{

    })
}